import React from 'react';
import { ColorArea as AriaColorArea, type ColorAreaProps as AriaColorAreaProps, composeRenderProps } from 'react-aria-components';
import { cn } from '../utils';
import { ColorThumb } from './ColorThumb';

export function ColorArea(props: AriaColorAreaProps) {
	return (
		<AriaColorArea
			{...props}
			className={composeRenderProps(props.className, className =>
				cn('h-56 w-56 rounded-lg bg-gray-300 forced-colors:bg-[GrayText]', className)
			)}
			style={({ defaultStyle, isDisabled }) => ({
				...defaultStyle,
				background: isDisabled ? undefined : defaultStyle.background
			})}
		>
			<ColorThumb />
		</AriaColorArea>
	);
}
